import { render, staticRenderFns } from "./Form20StyleOfProceeding.vue?vue&type=template&id=1dfebf47&scoped=true"
import script from "./Form20StyleOfProceeding.vue?vue&type=script&lang=ts"
export * from "./Form20StyleOfProceeding.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfebf47",
  null
  
)

export default component.exports